import { ProviderFiltroDashPg, ProviderFiltroTipoPg } from './context/FiltroDash';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './store';
import ProviderFiltroDash from './context/FiltroDash';
import FiltroDataProvider from './context/FiltroData';
import ProviderFiltro from './context/dadoFiltro';
import ProviderStyle from './Provider/ThemeProvider';
import AuthProvider from './context/Auth';
import ReactDOM from 'react-dom/client';
import Router from './router';
import './index.css';
import ProviderErrorSuccess from './Provider/ErrorSuccess';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);


const queryClient = new QueryClient();

root.render(
  <BrowserRouter >
    <ProviderErrorSuccess>
      <AuthProvider>
        <ProviderFiltroDash>
          <FiltroDataProvider>
            <ProviderFiltroDashPg>
              <ProviderFiltroTipoPg>
                <ProviderStyle>
                  <ProviderFiltro>
                    <Provider store={store}>
                      <QueryClientProvider client={queryClient}>
                        <Router />
                      </QueryClientProvider>
                    </Provider>
                  </ProviderFiltro>
                </ProviderStyle>
              </ProviderFiltroTipoPg>
            </ProviderFiltroDashPg>
          </FiltroDataProvider>
        </ProviderFiltroDash>
      </AuthProvider>
    </ProviderErrorSuccess>
  </BrowserRouter>
);

